<template>
  <div class="evaluation-header-info">
    <header class="text-right">
      <el-dropdown @command="clickOnItemDropDown">
        <span class="el-dropdown-link">
          <i class="icon-more_vert"/>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="showInfo">
            <span>
              Información de la evaluación
            </span>
          </el-dropdown-item>
          <el-dropdown-item command="exit">
            <span>
              Salir de la evaluación
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </header>
    <main>
      <h1>
        <span class="branch-type">
          {{ branch.type }}
        </span>
        {{ branchName }}
      </h1>
      <h2 :title="branch.dealer.name">{{ branch.dealer.name }}</h2>
    </main>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
export default {
  name: 'EvaluationHeaderInfo',
  components: {},
  props: {
    evaluation: {
      type: Object,
      required: true
    },
    branch: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    branchName () {
      return this.branch.municipality + ', ' + this.branch.state
    }
  },
  methods: {
    showInfo () {
      this.$emit('show-info')
    },
    exit () {
      this.$router.go(-1)
    },
    clickOnItemDropDown (command) {
      if (command === 'exit') {
        this.exit()
      } else if (command === 'showInfo') {
        this.showInfo()
      }
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.evaluation-header-info {
  background-color: #fff;
  header {
    .el-dropdown-link {
      font-size: 16px;
      padding: 10px;
      display: inline-block;
    }
  }
  main {
    padding: 20px;
    h1 {
      @include font-primary(16px, bold);
      margin: 0;
      padding: 0;
    }
    h2 {
      @include font-primary(12px, regular);
      display: block;
      overflow: hidden;
      margin: 0;
      max-width: 100%;
      padding: 0 0 0 28px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .branch-type {
      width: 20px;
      height: 20px;
      display: inline-block;
      border: 1px solid $color-ui-primary;
      color: $color-ui-primary;
      text-align: center;
      border-radius: 2px;
      background-color: #fff;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
      margin-right: 5px;
      vertical-align: text-bottom;
      line-height: 18px;
      @include font-primary(14px, regular);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/layout/evaluation-header-info.vue